import {CustomValueEntityBase} from "@/entities/interfaces/i-custom-value";

export default class PartnerIntraCustomValueEntity extends CustomValueEntityBase {
  constructor(init: Partial<PartnerIntraCustomValueEntity> = {}) {
    super(init);
  }
}
